import { render, staticRenderFns } from "./VxCellSelectableCheckbox.vue?vue&type=template&id=a4d66124&"
import script from "./VxCellSelectableCheckbox.vue?vue&type=script&lang=js&"
export * from "./VxCellSelectableCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports